module.exports = __webpack_public_path__ + "media/images/favicon/mstile-310x310-11d22344463f01072578769aedf037ec.png";